import { ProductDetailsPackage_MaterialVariantFragment } from "src/pages/configurator/OptionProductDetails.generated";

/**
 * Filter out fuel-specific ranges (e.g., "Gas Range (48in)") if a generic "Range (48in)" exists.
 * This is a temporary workaround until the backend properly handles GAS vs ELECTRIC range options.
 */
export function filterUniqueProducts(
  displayProducts: ProductDetailsPackage_MaterialVariantFragment[],
): ProductDetailsPackage_MaterialVariantFragment[] {
  return displayProducts.filter((product) => {
    const displayName = product.displayName;
    const measurementMatch = displayName.match(/\((\d+in)\)/);
    if (!measurementMatch) return true;
    const measurement = measurementMatch[0]; // e.g., "(48in)"
    // If this is "Gas Range (xxin)", check if generic "Range (xxin)" exists
    if (displayName.startsWith("Gas Range")) {
      const hasGenericRange = displayProducts.some((p) => p.displayName === `Range ${measurement}`);
      return !hasGenericRange; // Filter out if generic exists
    }
    return true;
  });
}
